import { combineReducers } from 'redux';
import netSalesSummary from './net-sales/net-sales-summary';
import isLoading from './net-sales/loading-status';
import instantGames from './net-sales/instant-games';
import drawGames from './net-sales/draw-games';

const netSales = combineReducers({
  netSalesSummary,
  isLoading,
  instantGames,
  drawGames,
});

export default netSales;



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/net-sales.reducer.js